import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Check, ArrowLeft } from "lucide-react";
import { Reveal, Overline } from "@/components/public/Reveal";
import CallbackForm from "@/components/public/CallbackForm";
import api, { fileUrl } from "@/lib/api";
import Seo from "@/components/Seo";

export default function ServiceDetail() {
  const { slug } = useParams();
  const [service, setService] = useState(null);

  useEffect(() => { api.get(`/services/${slug}`).then((r) => setService(r.data)).catch(() => {}); }, [slug]);
  if (!service) return <div className="pt-40 pb-40 text-center text-stone">Chargement…</div>;

  const ld = {
    "@context": "https://schema.org",
    "@type": "Service",
    serviceType: service.title,
    provider: { "@type": "LandscapingBusiness", name: "Acanthe Jardins" },
    areaServed: ["Bouches-du-Rhône", "Var", "Vaucluse"],
    description: service.description,
  };

  return (
    <div>
      <Seo title={service.title} path={`/prestations/${service.slug}`} description={service.description} image={service.image} jsonLd={ld} />
      <section className="relative h-[55vh] min-h-[380px] flex items-end" data-testid="service-hero">
        <img src={fileUrl(service.image)} alt={service.title} className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 hero-overlay" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-12 w-full pb-12">
          <Link to="/prestations" className="inline-flex items-center gap-2 text-cream/70 hover:text-cream text-sm mb-4"><ArrowLeft size={16} /> Toutes les prestations</Link>
          <h1 className="font-display text-5xl lg:text-6xl text-cream">{service.title}</h1>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid lg:grid-cols-[1.4fr_1fr] gap-16">
        <Reveal>
          <Overline>Le service</Overline>
          <p className="mt-4 text-lg text-stone leading-relaxed">{service.description}</p>
          <div className="mt-10 grid sm:grid-cols-2 gap-4">
            {["Diagnostic personnalisé", "Devis gratuit et détaillé", "Équipe qualifiée", "Matériel professionnel", "Respect des délais", "Suivi de chantier"].map((f) => (
              <div key={f} className="flex items-center gap-3 rounded-xl bg-sage/60 p-4">
                <Check className="text-brand shrink-0" size={18} /> <span className="text-sm text-forest font-medium">{f}</span>
              </div>
            ))}
          </div>
          <div className="mt-10 rounded-2xl bg-forest p-8 text-cream">
            <h3 className="font-display text-2xl mb-2">Un projet de {service.title.toLowerCase()} ?</h3>
            <p className="text-cream/70 text-sm mb-5">Nos experts interviennent dans les Bouches-du-Rhône, le Var et le Vaucluse.</p>
            <Link to="/contact" className="inline-flex rounded-full bg-terracotta px-6 py-3 font-semibold text-forest hover:bg-cream transition-colors">Demander un devis</Link>
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="sticky top-28 rounded-2xl bg-white border border-border p-7 shadow-sm">
            <h3 className="font-display text-2xl text-forest mb-1">Être rappelé</h3>
            <p className="text-sm text-stone mb-5">Laissez-nous vos coordonnées</p>
            <CallbackForm compact defaultService={service.title} />
          </div>
        </Reveal>
      </section>
    </div>
  );
}
